//------------------imports---------------------
import React, { useState, useEffect } from "react";
import {
  Grid,
  Box,
  Breadcrumbs,
  Link,
  AppBar,
  Stack,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  TextField,
  InputAdornment,
  useMediaQuery,
  Typography,
  Paper,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Navbar from "../../components/common/Navbar";
import AddToolbar from "../../components/common/AddToolbar";
import { externalgetApi } from "../../services/external/externalApis";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { useStyles } from "../../assets/styles/Theme";
import Addradio from "../../components/setting/Addradio";
import { Slide } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { FILESERVERURL, IMAGEBASEURL } from "../../config/Config";
import {
  SETTINGS_API_02,
  CHAINCODE,
  SETTINGS_API_03,
  COMMON_API_02,
  Unit_01,
  images_01,
  MENUCATCODE,
  ENUSER,
  SETTINGS_API_26,
} from "../../api/ApiModel";
import {
  CON_STATUS_ACTIVE,
  CON_MENU_TYPE_CODE,
  CON_STATUS_KITCHEN,
  CON_MAX_FILESIZE_ITEMIMG,
  CON_MENUICON_WIDTH,
  CON_MENUICON_HEIGHT,
  CON_REGEX_LNS_150,
} from "../../utils/sys/Constants";

import { externalpostApi } from "../../services/external/externalApis";
import { Tabs, Tab } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ImageCropper from "../../components/common/ImageCropper";

const AddItems = () => {
  //---------------hooks-------------------
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE, USERNAME, BUSINESSTYPECODE } =
    SYS_USER.USER_PARAM || {};
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);
  const location = useLocation();
  const names = ["unit", "KG", "M", "KM"];
  const { selectedItem } = location.state || {};
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const [data, setData1] = useState([]);
  const [dataitem, setDataitem] = useState([]);
  const [data2, setData2] = useState([]);
  const [error, setError] = useState(null);

  const [error2, setError2] = useState(null);
  const [error3, setError3] = useState(null);
  const [imageUrl, setImageUrl] = useState("");
  const [images, setImages] = useState([]);
  const [selectedImageUrl, setSelectedImageUrl] = useState("");
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const isEdit = location.state?.actionText === "Edit";
  const isSmallScreen = useMediaQuery("(max-width:600px)"); // Adjust breakpoint as needed
  const marginLeftImage = isSmallScreen
    ? selectedImageUrl
      ? 60
      : 60
    : selectedImageUrl
    ? 115
    : 95;
  const options = [
    { label: "Yes", value: "Y" },
    { label: "No", value: "N" },
  ];

  const options1 = [
    { label: "Yes", value: "A" },
    { label: "No", value: "N" },
  ];
  const [matchingItem, setMatchingItem] = useState({
    MENUCATNAME: "",
    MENUCATCODE: "",
    MENUNAME: "",
    BRANDNAME: "",
    COMMONNAME: "",
    ITEMRATE: "",
    DISCOUNTRATE: "",
    ISTAXAPPLY: "",
    KITCHENITEM: "",
    STS: "",
    MEASURINGUNIT: "",
    MINORDERLEVEL: "",
    BARCODE: "",
    REMARK: "",
    IMAGEPATH: "",
    MENUCODE: "",
    DISPLAYITEM: "",
    BYTEARRAY: "",
  });
  const [previewImage, setPreviewImage] = useState(null);

  const gotToView = () => {
    navigate("/ViewaddItem");
  };

  const [tabIndex, setTabIndex] = useState(0);
  const [croppedImg, setCroppedImg] = useState("");

  useEffect(() => {
    fetchData();
    fetchDataimage();
    fetchDataitems();
    fetchDataunits();
  }, []);

  useEffect(() => {
    if (selectedItem) {
      setMatchingItem({
        MENUCATNAME: String(selectedItem.MENUCATNAME),
        MENUNAME: String(selectedItem.NAME),
        BRANDNAME: String(selectedItem.BRANDNAME),
        COMMONNAME: String(selectedItem.COMMONNAME),
        ITEMRATE: String(selectedItem.ITEMRATE),
        DISCOUNTRATE: String(selectedItem.DISCOUNTRATE),
        ISTAXAPPLY: String(selectedItem.ISTAXAPPLY),
        KITCHENITEM: String(selectedItem.KITCHENITEM),
        STS: String(selectedItem.STS),
        MEASURINGUNIT: String(selectedItem.MEASURINGUNIT),
        MINORDERLEVEL: String(selectedItem.MINORDERLEVEL),
        BARCODE: String(selectedItem.BARCODE),
        REMARK: String(selectedItem.REMARK),
        selectedImageUrl: String(selectedItem.IMAGEPATH), // Ensure this is correct
        MENUCODE: String(selectedItem.MENUCODE),
        MENUCATCODE: String(selectedItem.MENUCATCODE),
        DISPLAYITEM: String(selectedItem.DISPLAYITEM),
        BYTEARRAY: selectedItem.BYTEARRAY,
      });
    }
  }, [selectedItem]);

  useEffect(() => {
    if (selectedItem && data.length > 0) {
      const foundItem = selectedItem;
      if (foundItem.MENUCATCODE) {
        const correspondingCategory = data.find(
          (item) => item.MENUCATCODE === foundItem.MENUCATCODE
        );
        if (correspondingCategory) {
          foundItem.MENUCATNAME = correspondingCategory.MENUCATNAME;
        }
      }
      setMatchingItem(foundItem);
      setIsLoading(false);
    }
  }, [selectedItem, data]);

  useEffect(() => {
    if (selectedItem) {
      console.log("Selected Image URL:", selectedItem.IMAGEPATH); // Debugging
      setMatchingItem({
        // other fields
        selectedImageUrl: String(selectedItem.IMAGEPATH),
      });
    }
  }, [selectedItem]);

  //------------------functions----------------

  const fetchDataitems = async () => {
    try {
      const today = new Date();
      const formattedToday = `${today.getFullYear()}-${String(
        today.getMonth() + 1
      ).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")} 23:59:59`;
      const result = await externalgetApi(COMMON_API_02, "get", {
        COMPCODE,
        LOCCODE,
        RESTCODE,
        TODAY: formattedToday,
        STS: CON_STATUS_ACTIVE,
      });
      setDataitem(result);
    } catch (err) {
      setError(err);
    }
  };

  const fetchData = async () => {
    try {
      const result = await externalgetApi(SETTINGS_API_02, "get", {
        COMPCODE,
        LOCCODE,
        RESTCODE,
        MENUTYPECODE: CON_MENU_TYPE_CODE,
        STS: CON_STATUS_ACTIVE,
      });
      setData1(result);
      setIsLoading(false);
    } catch (err) {
      setError(err);
      setIsLoading(false);
    }
  };

  const fetchDataimage = async () => {
    try {
      const result = await externalgetApi(images_01, "get", {
        BUSINESSTYPECODE,
      });
      if (Array.isArray(result)) {
        setImages(result);
      } else {
        console.error("Expected an array, got:", result);
        setImages([]); // Set an empty array to avoid errors
      }
    } catch (err) {
      console.error("Error fetching image options:", err);
      setError(true);
    }
  };

  const fetchDataunits = async () => {
    try {
      const result = await externalgetApi(SETTINGS_API_26, "get", {
        COMPCODE,
        LOCCODE,
        RESTCODE,

        STS: CON_STATUS_ACTIVE,
      });
      console.log("API response:", result); // Log API response

      setData2(result);
    } catch (err) {
      console.error("Error fetching data:", err);
      setError(err);
    }
  };
  //---------------handlers-----------
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if (!CON_REGEX_LNS_150.test(value)) {
      return;
    }
    // Clear the error for the specific field when the user starts typing
    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
    setMatchingItem((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleImageClick = async (image) => {
    const imageUrl = `${IMAGEBASEURL}${image.IMAGEPATH.replace("~", "")}`;
    setSelectedImageUrl(imageUrl);
    console.log("Selected Image URL:", `${imageUrl}`);
  };

  const handleCroppedImage = (img) => {
    setCroppedImg(img);

    console.log("Received cropped image from child:", img);
  };

  //--------postapi-----------------
  const handleConfirmClick = async () => {
    const {
      MENUCATNAME,
      MENUNAME,
      BRANDNAME,
      COMMONNAME,
      ITEMRATE,
      DISCOUNTRATE,
      ISTAXAPPLY,
      KITCHENITEM,
      STS,
      MENUCATCODE,
      MEASURINGUNIT,
      MINORDERLEVEL,
      BARCODE,
      REMARK,
      MENUCODE,
      IMAGEPATH,
      DISPLAYITEM,
    } = matchingItem;

    // Required fields with labels
    const requiredFields = [
      { name: "MENUCATCODE", value: MENUCATCODE, label: "Item Category" },
      { name: "MENUNAME", value: MENUNAME, label: "Item Name" },
      { name: "ITEMRATE", value: ITEMRATE, label: "Item Rate" },
      { name: "DISCOUNTRATE", value: DISCOUNTRATE, label: "Discount Rate" },
    ];

    const missingRequiredFields = requiredFields.filter(
      (field) => !field.value
    );
    if (missingRequiredFields.length > 0) {
      const newError = {};
      missingRequiredFields.forEach((field) => {
        newError[field.name] = `${field.label} is required.`; // Set error message for each missing field
      });

      setErrors(newError); // Set the error state
      const missingFieldLabels = missingRequiredFields
        .map((field) => field.label)
        .join(", ");
      const errorMessage = `Please Fill All the Required Fields.`;

      setSnackbarMessage(errorMessage); // Show snackbar with missing fields
      setOpenErrorSnackbar(true);
      return; // Stop submission if there are validation errors
    }

    if (dataitem) {
      const isDuplicate = dataitem.some((item) => {
        if (
          item.MENUCODE != matchingItem.MENUCODE &&
          item.MENUNAME === MENUNAME
        ) {
          return true;
        } else {
          return false;
        }
      });

      if (isDuplicate) {
        setSnackbarMessage("Item already exists."); // Show snackbar if duplicate found
        setOpenErrorSnackbar(true);
        return;
      }
    }

    const optionalFields = {
      MEASURINGUNIT,
      BRANDNAME,
      COMMONNAME,
      ISTAXAPPLY,
      KITCHENITEM,
      MINORDERLEVEL: MINORDERLEVEL || "0", // Default to 0 if undefined or empty
      MENUCATNAME,
      BARCODE,
      REMARK,
      IMAGEPATH: selectedImageUrl || matchingItem.IMAGEPATH,
    };

    const staticValues = {
      COMPCODE,
      LOCCODE,
      RESTCODE,
      STS: CON_STATUS_ACTIVE,
      CHAINCODE,
      BUSINESSTYPECODE,
      LOCDATE: new Date().toISOString(),

      MENUREFCODE: "",
      TAXCODE: "N",
      ENUSER: USERNAME,
      WEBIMAGEPATH: "asd.jpg",
    };
    // Combine matchingItem, staticValues, and convert all values to strings
    const payload = {
      ...matchingItem,
      MENUCODE: String(matchingItem.MENUCODE),
      BYTEARRAY: croppedImg.length > 0 ? String(croppedImg.split(",")[1]) : "",

      ...staticValues,
      ...optionalFields,
    };

    try {
      console.log("Payload for API call:", payload);
      const responseData = await externalpostApi(SETTINGS_API_03, payload);
      console.log("Success:", responseData);
      setOpenSnackbar(true); // Show success snackbar
      handleClearClick(); // Clear form fields after success
    } catch (error) {
      console.error("Error:", error);
    }

    setTimeout(() => {
      navigate("/ViewaddItem");
    }, 2000);
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  const handleClearClick = () => {
    setMatchingItem({
      MENUCATNAME: "",
      MENUNAME: "",
      BRANDNAME: "",
      COMMONNAME: "",
      ITEMRATE: "",
      DISCOUNTRATE: "",
      ISTAXAPPLY: "",
      KITCHENITEM: "",
      STS: "",
      MEASURINGUNIT: "",
      MINORDERLEVEL: "",
      BARCODE: "",
      REMARK: "",
      IMAGEPATH: "",
      BYTEARRAY: "",
    });
    setSelectedImageUrl("");
  };
  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorSnackbar(false); // Reset the snackbar state
  };

  //------------------Validations-------------------

  const formatNumber = (value) => {
    return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const handleRateChange = (event) => {
    const { name, value } = event.target;

    const rawValue = value.replace(/,/g, "");

    if (!isNaN(rawValue)) {
      const formattedValue = formatNumber(rawValue);
      handleInputChange({ target: { name, value: formattedValue } });
    }
  };

  const handleInputValidation = (event) => {
    const { name, value } = event.target;

    // Allow only letters and spaces
    const regex = /^[a-zA-Z\s]*$/;
    if (regex.test(value)) {
      setError("");
      handleInputChange(event);
    } else {
      setError("Only letters and spaces are allowed.");
    }
  };

  const validateItemname = (event) => {
    const { value } = event.target;

    if (typeof value === "string" && value.length > 150) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        MENUNAME: "Item name cannot exceed 150 characters.",
      }));
      return;
    }

    const regex = /^[a-zA-Z0-9\s,./*()[\]&]*$/;
    if (regex.test(value)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        MENUNAME: "",
      }));
      handleInputChange(event);
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        MENUNAME:
          "Only letters, numbers, spaces, and , . / * () [] & are allowed.",
      }));
    }
  };

const handlenrateInputValidation = (event) => {
  const { name, value } = event.target;

  const regex = /^[0-9]*\.?[0-9]*$/;

  if (regex.test(value)) {
    setErrors((prev) => ({
      ...prev,
      [name]: ""
    }));
    handleInputChange(event);
  } else {
    setErrors((prev) => ({
      ...prev,
      [name]: "Only numbers and floats are allowed."
    }));
  }
};

  const handlenumInputValidation = (event) => {
    const { name, value } = event.target;

    const regex = /^[0-9]*\.?[0-9]*$/;

    if (regex.test(value)) {
      setError2("");
      handleInputChange(event);
    } else {
      setError2("Only numbers and floats are allowed.");
    }
  };



const handledrateInputValidation = (event) => {
  const { name, value } = event.target;

  // Allow only numbers with an optional decimal (max 2 decimal places)
  const regex = /^\d*(\.\d{0,2})?$/;

  // Check invalid characters and decimal format
  if (!regex.test(value)) {
    setErrors((prev) => ({
      ...prev,
      [name]: "Only numbers and floats are allowed.",
    }));
    return;
  }

  // Check maximum value
  const numericValue = parseFloat(value);

  if (value !== "" && !isNaN(numericValue) && numericValue > 100) {
    setErrors((prev) => ({
      ...prev,
      [name]: "Value cannot be greater than 100.",
    }));
    return;
  }

  // Valid input: clear error and update state
  setErrors((prev) => ({
    ...prev,
    [name]: "",
  }));

  handleInputChange(event);
};

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Settings</Link>
                <Link underline="none">{isEdit ? "Edit Item Details" : "Create Item Details"}</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6} p={2}>
              <Stack
                sx={{
                  ...styles.AI_fixedStack2,
                  direction: "row",
                  justifyContent: "flex-end",
                }}
                // spacing={2}
                // padding={1}
              >
                <Button
                  onClick={gotToView}
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "1px",
                    width: "80px",
                  }}
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box sx={styles.AI_AddStyledBox}>
        <AddToolbar
          label={{ name: isEdit ? "Edit Item Details" : "Create Item Details" }}
        />
        <Grid container spacing={2} sx={styles.AI_container}>
          <Grid item spacing={2} xs={12} sm={12} md={6} lg={6}>
            <Grid item xs={12} sm={12}>
              <FormControl size="small" fullWidth>
                <Autocomplete
                  options={data}
                  getOptionLabel={(option) => option.MENUCATNAME}
                  value={
                    data.find(
                      (item) => item.MENUCATNAME == matchingItem.MENUCATNAME
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    handleInputChange({
                      target: {
                        name: "MENUCATNAME",
                        value: newValue ? newValue.MENUCATNAME : "",
                      },
                    });
                    handleInputChange({
                      target: {
                        name: "MENUCATCODE",
                        value: newValue ? String(newValue.MENUCATCODE) : "",
                      },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                     
                       label={
                  <span>
                   Item Category<span style={{ color: "red" }}> *</span>
                  </span>
                }
                      variant="outlined"
                      size="small"
                        error={Boolean(errors.MENUCATCODE)}
                helperText={errors.MENUCATCODE}
                    />
                  )}
                  ListboxProps={{
                    style: {
                      maxHeight: 150,
                      backgroundColor: theme.palette.background.paper,
                    },
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} mt={2}>
              <TextField
                name="MENUNAME"
                label={
                  <span>
                    Item Name<span style={{ color: "red" }}> *</span>
                  </span>
                }
                size="small"
                fullWidth
                variant="outlined"
                autoComplete="off"
                value={matchingItem.MENUNAME || ""}
                onChange={validateItemname}
                error={Boolean(errors.MENUNAME)}
                helperText={errors.MENUNAME}
              />
            </Grid>

            <Grid item xs={12} sm={12} mt={2}>
              <TextField
                name="BRANDNAME"
                label="Brand Name"
                fullWidth
                size="small"
                variant="outlined"
                autoComplete="off"
                value={matchingItem.BRANDNAME || ""}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} sm={12} mt={2}>
              <TextField
                name="COMMONNAME"
                label="Common Name"
                fullWidth
                size="small"
                variant="outlined"
                autoComplete="off"
                value={matchingItem.COMMONNAME || ""}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} sm={12} mt={2}>
              <TextField
                name="ITEMRATE"
                label={
                  <span>
                    Rate<span style={{ color: "red" }}> *</span>
                  </span>
                }
                fullWidth
                size="small"
                variant="outlined"
                autoComplete="off"
                value={matchingItem.ITEMRATE || ""}
                onChange={handlenrateInputValidation} // Ensure function is correctly used
                error={Boolean(errors.ITEMRATE)}
                helperText={errors.ITEMRATE}
              />
            </Grid>
            <Grid item xs={12} sm={12} mt={2}>
              <TextField
                name="DISCOUNTRATE"
                label={
                  <span>
                    Discount Rate(%)<span style={{ color: "red" }}> *</span>
                  </span>
                }
                fullWidth
                size="small"
                variant="outlined"
                autoComplete="off"
                value={matchingItem.DISCOUNTRATE || ""}
                onChange={handledrateInputValidation} // Ensure function is correctly used
                error={Boolean(errors.DISCOUNTRATE)}
                helperText={errors.DISCOUNTRATE}
              />
            </Grid>

            <Grid item xs={12} sm={12} mt={2}>
              <TextField
                name="MINORDERLEVEL"
                label="Minimum Order Level"
                size="small"
                fullWidth
                variant="outlined"
                autoComplete="off"
                value={matchingItem.MINORDERLEVEL || ""}
                onChange={handlenumInputValidation} // Ensure function is correctly used
                error={!!error2}
                helperText={error2}
              />
            </Grid>
            <Grid item xs={12} sm={12} mt={2}>
              <FormControl fullWidth size="small">
                <Autocomplete
                  options={data2}
                  getOptionLabel={(option) => option.MEASURINGUNIT || ""} // Ensure a fallback for undefined values
                  value={
                    data2.find(
                      (item) => item.MEASURINGUNIT == matchingItem.MEASURINGUNIT
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    handleInputChange({
                      target: {
                        name: "MEASURINGUNIT",
                        value: newValue ? newValue.MEASURINGUNIT : "", // Set MEASURINGUNIT or empty string
                      },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Measuring Unit"
                      size="small"
                      name="MEASURINGUNIT"
                      error={Boolean(errors.MEASURINGUNIT)}
                      helperText={errors.MEASURINGUNIT}
                    />
                  )}
                  ListboxProps={{
                    style: {
                      maxHeight: 150,
                      backgroundColor: theme.palette.background.paper,
                    },
                  }}
                />
              </FormControl>
            </Grid>
          </Grid>
          <Grid item spacing={2} xs={12} sm={12} md={6} lg={6}>
            {/* <Grid item xs={12} sm={12}>
              <FormControl fullWidth size="small">
                <Autocomplete
                  options={options}
                  getOptionLabel={(option) => option.label}
                  value={
                    options.find(
                      (option) => option.value === matchingItem.KITCHENITEM
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    handleInputChange({
                      target: {
                        name: "KITCHENITEM",
                        value: newValue ? newValue.value : "",
                      },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Kitchen Item"
                      variant="outlined"
                      size="small"
                    />
                  )}
                  ListboxProps={{
                    style: {
                      maxHeight: 150,
                      backgroundColor: theme.palette.background.paper,
                    },
                  }}
                />
              </FormControl>
            </Grid> */}

            <Grid item xs={12} sm={12} mt={0}>
              <FormControl fullWidth size="small">
                <Autocomplete
                  options={options}
                  getOptionLabel={(option) => option.label}
                  value={
                    options.find(
                      (option) => option.value === matchingItem.ISTAXAPPLY
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    handleInputChange({
                      target: {
                        name: "ISTAXAPPLY",
                        value: newValue ? newValue.value : "",
                      },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Special Tax Applied (Reporting purpose)"
                      variant="outlined"
                      size="small"
                    />
                  )}
                  ListboxProps={{
                    style: {
                      maxHeight: 150,
                      backgroundColor: theme.palette.background.paper,
                    },
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} mt={2}>
              <TextField
                name="REMARK"
                label="Remark"
                size="small"
                fullWidth
                variant="outlined"
                autoComplete="off"
                value={matchingItem.REMARK || ""}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} sm={12} mt={2}>
              <TextField
                name="BARCODE"
                label="Barcode"
                size="small"
                fullWidth
                variant="outlined"
                autoComplete="off"
                value={matchingItem.BARCODE || ""}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} sm={12} mt={2}>
              <Tabs
                value={tabIndex}
                onChange={(e, newIndex) => setTabIndex(newIndex)}
              >
                <Tab label="Select Icon" />
                <Tab label="Upload Image" />
              </Tabs>
            </Grid>
            {tabIndex === 0 && (
              <Grid container spacing={3}>
                {/* <Addradio value={matchingItem.IMAGEPATH} /> */}
                <Grid item xs={8} sm={8} md={8} lg={8} xl={8} mt={2}>
                  <TextField
                    name="IMAGEPATH"
                    value={selectedImageUrl} // Display the selected image URL
                    label="Icons"
                    fullWidth
                    sx={{
                      height: 180,
                      "& .MuiInputBase-root": {
                        height: "100%",
                        width: "min-content",
                      },
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              mt: 1,
                              maxWidth: {
                                xs: "400px",
                                sm: "600px",
                                md: "900px",
                                lg: "1200px",
                                xl: "1536px",
                              },
                              // width: "100%",
                              height: 150,
                              overflowY: "auto",
                              border: "1px solid #ddd",
                            }}
                          >
                            <Box
                              sx={{
                                display: "grid",
                                gridTemplateColumns: {
                                  xs: "repeat(4, 1fr)", // On extra-small screens, 3 columns
                                  sm: "repeat(8, 1fr)", // On small screens, 4 columns
                                  md: "repeat(8, 1fr)", // On medium and larger, 5 columns
                                  lg: "repeat(12, 1fr)",
                                  xl: "repeat(12, 1fr)",
                                },
                                gap: "8px",
                                width: "100%",
                              }}
                            >
                              {images.map((image) => (
                                <img
                                  key={image.IMAGEPATH}
                                  src={`${IMAGEBASEURL}${image.IMAGEPATH.replace(
                                    "~",
                                    ""
                                  )}`}
                                  alt="Icon"
                                  style={{
                                    width: "30px",
                                    height: "30px",
                                    cursor: "pointer",
                                    verticalAlign: "middle",
                                  }}
                                  onClick={() => handleImageClick(image)}
                                />
                              ))}
                            </Box>
                          </Box>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                  <Box
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    height={"100%"}
                  >
                    {(selectedImageUrl || matchingItem?.IMAGEPATH) && (
                      <img
                        src={
                          selectedImageUrl
                            ? `${selectedImageUrl}` // Use selectedImageUrl if available
                            : `${matchingItem?.IMAGEPATH}` // Use matchingItem?.IMAGEPATH as fallback
                        }
                        alt="Selected or Matching Item"
                        style={{
                          // width: "100px",
                          height: "auto",
                          maxHeight: "100px",
                          // marginTop: "20%",
                          // marginLeft: marginLeftImage,

                          cursor: "pointer",
                        }}
                      />
                    )}
                  </Box>
                </Grid>
              </Grid>
            )}
            {tabIndex === 1 && (
              <Grid container spacing={1} mt={0}>
                <Grid item xs={6} sm={6} md={6} lg={6} xl={6} pt={0}>
                  <Box>
                    <ImageCropper
                      onCropComplete={handleCroppedImage}
                      FIXED_WIDTH={CON_MENUICON_WIDTH}
                      FIXED_HEIGHT={CON_MENUICON_HEIGHT}
                      MAX_FILESIZE={CON_MAX_FILESIZE_ITEMIMG}
                      setSnackbarMessage={setSnackbarMessage}
                      setOpenErrorSnackbar={setOpenErrorSnackbar}
                      setMatchingItem={setMatchingItem}
                    />
                  </Box>
                </Grid>

                <Grid item xs={6} sm={6} md={6} lg={6} xl={6} pt={0}>
                  {croppedImg && (
                    <Box sx={{ flexDirection: "column", alignItems: "end" }}>
                      <Typography variant="subtitle1">Preview:</Typography>
                      <Paper
                        elevation={3}
                        sx={{ width: "fit-content", padding: 2 }}
                      >
                        <img
                          src={croppedImg}
                          alt="Cropped Result"
                          style={{ width: 150, height: 150 }}
                        />
                      </Paper>
                    </Box>
                  )}
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>

        <Stack
          direction="row"
          spacing={2}
          m={2}
          justifyContent="flex-end"
          padding={1}
          mt={1}
        >
          <Button
            variant="outlined"
            sx={styles.AI_button1}
            onClick={handleClearClick}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            sx={styles.AI_button2}
            onClick={handleConfirmClick}
          >
            {isEdit ? "Modify" : "Confirm"}
          </Button>
        </Stack>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={4000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity="success"
            sx={{ width: "100%" }}
          >
            {isEdit ? " Updated Successfully!" : " Created Successfully!"}
          </Alert>
        </Snackbar>

        <Snackbar
          open={openErrorSnackbar}
          message={snackbarMessage}
          autoHideDuration={3000}
          onClose={handleErrorSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleErrorSnackbarClose}
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage || "Please fill out all fields before submitting."}
          </Alert>
        </Snackbar>
      </Box>
    </div>
  );
};

export default AddItems;
